

export class UtilitiesString{
    static emptyString(str: string) {
       return (str || '').trim().length === 0;
    }

    /**
     * Return the result of the comparition of two strings taking in consideration that the strings coulds contain numbers (ex: version comparison)
     * @param a First string
     * @param b Second string
     */
    static compareStringWithNumbers(a: string, b: string){
        return( a.localeCompare( b, undefined, { numeric: true } ) );
    }
}
